import Frame from '../Frame/Frame';

import Cue   from './Cue';
import Track from './Track';

class Captions {
    public frame: Frame = null;
    public tracks: Track[] = [];
    public activeCues: Cue[] = [];

    public get activeTrack(): Track {
        return this.tracks.find(track => track.isActive) || null;
    }

    public get areCaptionsActive(): boolean {
        return this.activeTrack !== null;
    }
}

export default Captions;